// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AKYX","top":"styles_top__3Vg1d"};